import React, { memo } from 'react';
import { RouteComponentProps, Switch } from 'react-router-dom';

import { PrivateRoute } from '@/core/components/private-route';
import { authenticatedRoutePaths, authenticatedRoutes, generateRoutes, GuardProps, RoutesDef } from '@/core/navigation';
import { VoucherRedeemFormPage } from './pages/voucher-redeem-form';
import { VoucherRedeemMapSuccessPage } from './pages/voucher-redeem-map-success';
import { VoucherRedeemSubscriptionSuccessPage } from './pages/voucher-redeem-subscription-success';
import { authenticatedGuard } from './services/authenticated.guard';

const authenticatedRoutesDef: RoutesDef<authenticatedRoutes> = {
  [authenticatedRoutes.VOUCHER_REDEEM_FORM]: {
    path: authenticatedRoutePaths[authenticatedRoutes.VOUCHER_REDEEM_FORM],
    component: VoucherRedeemFormPage,
  },
  [authenticatedRoutes.VOUCHER_MAP_REDEEM_SUCCESS]: {
    path: authenticatedRoutePaths[authenticatedRoutes.VOUCHER_MAP_REDEEM_SUCCESS],
    component: VoucherRedeemMapSuccessPage,
  },
  [authenticatedRoutes.VOUCHER_SUBSCRIPTION_REDEEM_SUCCESS]: {
    path: authenticatedRoutePaths[authenticatedRoutes.VOUCHER_SUBSCRIPTION_REDEEM_SUCCESS],
    component: VoucherRedeemSubscriptionSuccessPage,
  },
};

const routes = generateRoutes(authenticatedRoutesDef, 'authenticated', authenticatedRoutePaths[authenticatedRoutes.VOUCHER_REDEEM_FORM]);
const AuthenticatedRoutes = memo<GuardProps>(() => <Switch>{routes}</Switch>);

export default memo<RouteComponentProps>((props) => <PrivateRoute guard={authenticatedGuard} component={AuthenticatedRoutes} {...props} />);
